import axios from "axios";
import { getCookie } from "./helpers";
import {cf} from "./index";

export const request = (config) => {
    return new Promise((resolve, reject) => {
        axios({
            method: config.method,
            url: cf.SSO_URL + config.url,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "x-access-token": `${getCookie("user_token")}`,
            },
        })
            .then(resolve)
            .catch(reject);
    });
};

export const accountApi = {
    get: (url) =>
        request({
            method: "GET",
            url,
        }),
};
